import { React } from '../../shared/react.js';
import { Icon } from '../../shared/icons.js';

export function MapControls(props: {
  readonly onZoomIn: () => void;
  readonly onZoomOut: () => void;
  readonly onReset: () => void;
  readonly onExpand: () => void;
}) {
  return (
    <div className="map-controls" aria-label="Map controls">
      <button type="button" onClick={props.onZoomIn} aria-label="Zoom in"><Icon name="plus" size={18}/></button>
      <button type="button" onClick={props.onZoomOut} aria-label="Zoom out"><Icon name="minus" size={18}/></button>
      <button type="button" onClick={props.onReset} aria-label="Center map"><Icon name="target" size={18}/></button>
      <span className="map-controls__break"/>
      <button type="button" onClick={props.onExpand} aria-label="Toggle fullscreen"><Icon name="expand" size={18}/></button>
    </div>
  );
}
